/* generated by Svelte v3.9.1 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	space,
	text
} from "svelte/internal";
import { FIGURES } from "src/constants"
import { grid, gridSize } from "src/store.js"
import { drawFiguresInGrid, fillGridWithRnd } from "src/gridHelper"

function get_each_context(ctx, list, i) {
	const child_ctx = Object.create(ctx);
	child_ctx.item = list[i];
	child_ctx.i = i;
	return child_ctx;
}

// (31:4) {#each FIGURES as item, i}
function create_each_block(ctx) {
	var option, t0_value = ctx.item.title + "", t0, t1;

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();
			option.__value = ctx.i;
			option.value = option.__value;
		},

		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);
		},

		p: noop,

		d(detaching) {
			if (detaching) {
				detach(option);
			}
		}
	};
}

function create_fragment(ctx) {
	var div, label, t1, select, select_value_value, t2, button, dispose;

	var each_value = FIGURES;

	var each_blocks = [];

	for (var i_1 = 0; i_1 < each_value.length; i_1 += 1) {
		each_blocks[i_1] = create_each_block(get_each_context(ctx, each_value, i_1));
	}

	return {
		c() {
			div = element("div");
			label = element("label");
			label.textContent = "Creature";
			t1 = space();
			select = element("select");

			for (var i_1 = 0; i_1 < each_blocks.length; i_1 += 1) {
				each_blocks[i_1].c();
			}

			t2 = space();
			button = element("button");
			button.textContent = "add";
			attr(select, "name", "pattern");
			attr(div, "class", "form-item");

			dispose = [
				listen(select, "change", ctx.onFigureChange),
				listen(button, "click", ctx.drawFigure)
			];
		},

		m(target, anchor) {
			insert(target, div, anchor);
			append(div, label);
			append(div, t1);
			append(div, select);

			for (var i_1 = 0; i_1 < each_blocks.length; i_1 += 1) {
				each_blocks[i_1].m(select, null);
			}

			select_value_value = ctx.selectedFigureIndex;
			for (var i = 0; i < select.options.length; i += 1) {
				var option = select.options[i];

				if (option.__value === select_value_value) {
					option.selected = true;
					break;
				}
			}

			append(div, t2);
			append(div, button);
		},

		p(changed, ctx) {
			if (changed.FIGURES) {
				each_value = FIGURES;

				for (var i_1 = 0; i_1 < each_value.length; i_1 += 1) {
					const child_ctx = get_each_context(ctx, each_value, i_1);

					if (each_blocks[i_1]) {
						each_blocks[i_1].p(changed, child_ctx);
					} else {
						each_blocks[i_1] = create_each_block(child_ctx);
						each_blocks[i_1].c();
						each_blocks[i_1].m(select, null);
					}
				}

				for (; i_1 < each_blocks.length; i_1 += 1) {
					each_blocks[i_1].d(1);
				}
				each_blocks.length = each_value.length;
			}

			if ((changed.selectedFigureIndex) && select_value_value !== (select_value_value = ctx.selectedFigureIndex)) {
				for (var i = 0; i < select.options.length; i += 1) {
					var option = select.options[i];

					if (option.__value === select_value_value) {
						option.selected = true;
						break;
					}
				}
			}
		},

		i: noop,
		o: noop,

		d(detaching) {
			if (detaching) {
				detach(div);
			}

			destroy_each(each_blocks, detaching);

			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $grid, $gridSize;

	component_subscribe($$self, grid, $$value => { $grid = $$value; $$invalidate('$grid', $grid); });
	component_subscribe($$self, gridSize, $$value => { $gridSize = $$value; $$invalidate('$gridSize', $gridSize); });

	

  let selectedFigureIndex = 0

  function drawFigure () {
    const newGrid = [...$grid]
    const figure = FIGURES[selectedFigureIndex].figure
    if (figure) {
      grid.set(drawFiguresInGrid({
        grid: newGrid,
        figure,
        gridSize: $gridSize,
      }))
    } else {
      fillGridWithRnd(newGrid, Math.round(($gridSize**2) / 7))
    }
    grid.set(newGrid)
  }

  function onFigureChange ({ target: { value }}) {
    $$invalidate('selectedFigureIndex', selectedFigureIndex = value)
  }

	return {
		selectedFigureIndex,
		drawFigure,
		onFigureChange
	};
}

class Component extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, []);
	}
}

export default Component;